import { invoke } from '@shared/easyfy.decorators';

@invoke
export default class IFrameComponent {
  static Instance: IFrameComponent;

  constructor() {
    IFrameComponent.Instance = this;
  }

  onInit() {
    window.addEventListener('message', IFrameComponent.adjustIframeHeight, false);
  }

  // Listens for messages from any iframe and adjusts the height to accommodate the content, adding 20 pixels for additional spacing
  static adjustIframeHeight(e: MessageEvent) {
    let message = e.data;

    if (!message || typeof message.id !== 'string' || typeof message.height !== 'number') {
      return;
    }

    let key = message.id.replace(/#/g, '');
    let selector = `[data-key-1="${key}"]`;
    let iframe = document.querySelector(selector) as HTMLElement | null;

    if (!iframe) {
      return;
    }

    if (!iframe.style) {
      return;
    }

    iframe.style.height = message.height + 20 + 'px';
  }
}
